// extracted by mini-css-extract-plugin
export default {"innerWrapper":"UA-z","tooltipWrapper":"VA-z","icon":"WA-z","tooltip":"XA-z","content":"YA-z"};